import type { Token } from "@ext/markdown/core/render/logic/Markdoc";
import type MarkdownIt from "markdown-it";

const isImage = (token: Token) => token.type === "image";

export const parseImageSize = (content: string) => {
	const match = content.match(/\{(.*?)\}/);
	if (!match) return null;

	// Braces hold a size only when they hold `name=value` pairs. Anything else after an image --
	// a word in curly braces, a formula -- is the text of the article and stays in it.
	const params = match[1]
		.split(" ")
		.map((param) => param.split("="))
		.filter(([name, value]) => name && value !== undefined);

	return params.length ? Object.fromEntries(params.map(([name, value]) => [name, value.replace(/['"]/g, "")])) : null;
};

const processTokensRecursively = (tokens: Token[]) => {
	for (let i = 0; i < tokens.length; i++) {
		const token = tokens[i];

		if (isImage(token)) {
			const nextToken = tokens?.[i + 1];
			if (!nextToken) continue;

			const params = parseImageSize(nextToken.content);
			if (!params) continue;
			if (params.width) token.attrSet("width", params.width);
			if (params.height) token.attrSet("height", params.height);
			// The width the picture was dragged to, which is not the width it was drawn at.
			if (params.scale) token.attrSet("scale", params.scale);

			nextToken.content = nextToken.content.replace(/\{.*?\}/, "");
			if (nextToken.children) nextToken.children = nextToken.children.splice(0, 1);
		}

		if (token.children) {
			processTokensRecursively(token.children);
		}
	}
};

function imgSizePlugin(md: MarkdownIt) {
	md.core.ruler.push("image-size", (state) => {
		processTokensRecursively(state.tokens);
	});
}

export default imgSizePlugin;
